import { useCheckoutMutation } from '@pff-consumer/data-provider/lib/account/account-api'
import { checkoutHooks } from '@pff-consumer/data-provider/lib/checkout/checkout.hooks'

const { useCheckoutActions, useIsEmailValid, useEmail, usePromoCode, useSelectedPlan, useVariant } = checkoutHooks

export const useCheckoutState = () => {
  const { validateEmail } = useCheckoutActions()
  const isEmailValid = useIsEmailValid()
  const plan = useSelectedPlan()
  const email = useEmail()
  const promoCode = usePromoCode()
  const [checkout, { isLoading }] = useCheckoutMutation()
  const variant = useVariant()

  return { validateEmail, isEmailValid, plan, email, promoCode, checkout, isLoading, variant }
}
